export enum SessionStorageKeys {
    LOGIN_HINT_DISPLAYED = 'login-hint-displayed',
    PREFERRED_LOGIN_EMAIL = 'preferred-login-email',
    ACTIVATION_FAILURE_MESSAGE = 'activation-failure-message',
    MFA_STEP_UP_ATTEMPTED = 'mfa-step-up-attempted',
    LOGIN_REDIRECT_ATTEMPTS = 'login-redirect-attempts',
}
